<!-- 文件上传ali oss -->
<template>
    <div>
        <el-upload
            class="upload"
            ref="upload"
            action=""
            :http-request="uploadFile"
            :accept="accept || ''"
            :show-file-list="false"
            :limit="limit ? limit : 10"
            multiple
            :before-upload="beforeUpload"
            :on-exceed="exceed">
            <div class="button upload">
                <i class="el-icon-upload2"></i>
                <span>上传</span>
            </div> &nbsp;&nbsp;
            <slot name="desc">
                <span slot="tip" class="el-upload__tip upload_desc">{{`附件数量上限${limit ? limit : 10}个，总大小不得超过${size ? size : 300}M`}}</span>
            </slot>
        </el-upload>
        <fileShow :fileList="fileList" :download="download || 'true'" @delFile="delFile"></fileShow>
    </div>
</template>
<script>
    import fileShow from './file-show'
    export default{
        name: 'upload',
        data() {
            return {
                file: {},
                fileList: [],
                fileSize: 0,
                tip: false
            }
        },
        /*
            files: 文件
            limit：数量限制
            size：大小限制
            fileDire: 上传目录
        */ 
        props: ['files' ,'limit', 'size', 'fileDire', 'download', 'accept'],
        watch: {
        },
        components: {
            fileShow
        },
        created() {
            this.fileList = this.files ? this.files : [];
        },
        methods: {
            init() {
                this.fileList = [];
                this.fileSize = 0;
                this.tip = false;
                this.$refs.upload.clearFiles();
            },
            uploadFile(file) {
                /*
                    压缩图片
                    上传alioss 上传展示的文件需要转成blob 创建链接展示
                    上传alioss接口uploadAliOss，第一个参数为oss存储地址+文件名字，第二个参数为上传的文件
                */
                this.file = file;
                this.compress(file.file, this.compressSuccess);
                
            },
            compressSuccess(file) {
                this.imageUrl = window.URL.createObjectURL(new Blob([file]));
                const timestamp = new Date().getTime();
                let directory;
                if(this.fileDire) {
                    directory = this.fileDire + '/_' + file.name;
                }else{
                    directory = `op${this.$route.path}/${this.formDate(timestamp, 'YYYYMMDD')}/${timestamp+'_'+file.name}`;
                }
                this.uploadAliOss(directory, file).then(data => {
                    this.api.getOssUrl({path: decodeURIComponent((data[0].split('aliyuncs.com/')[1]).split('?')[0])}).then(res => {
                        this.fileList.forEach((item, i) => {
                            if(item.uid == file.uid) {
                                this.$set(this.fileList, i, res.data);
                                this.$emit('fileChange', decodeURIComponent((data[0].split('aliyuncs.com/')[1]).split('?')[0]), 'upload');
                            }
                        })
                    })
                    
                }).catch(() => {
                    this.fileList.forEach((item, i) => {
                        if(item.uid == file.uid) {
                            this.fileSize -= this.fileList[i].size;
                            this.fileList.splice(i, 1);
                            this.$refs.upload.abort(this.file);
                            this.$refs.upload.uploadFiles.splice(i, 1);
                        }
                    })
                });
            },
            compress(fileObj, callback) {  //文件压缩
                try {
                    if(fileObj.type.indexOf('image') == -1 || fileObj.size < 1024000) {
                        callback(fileObj);
                        return;
                    }
                    const _this = this;
                    const image = new Image()
                    image.src = window.URL.createObjectURL(new Blob([fileObj]))
                    image.onload = function() {
                        const that = this
                        // 默认按比例压缩
                        let w = that.width
                        let h = that.height
                        const scale = w / h
                        w = fileObj.width || w
                        h = fileObj.height || (w / scale)
                        let quality = this.quality || 0.7 // 默认图片质量为0.7
                        // 生成canvas
                        const canvas = document.createElement('canvas')
                        const ctx = canvas.getContext('2d')
                        // 创建属性节点
                        const anw = document.createAttribute('width')
                        anw.nodeValue = w
                        const anh = document.createAttribute('height')
                        anh.nodeValue = h
                        canvas.setAttributeNode(anw)
                        canvas.setAttributeNode(anh)
                        ctx.drawImage(that, 0, 0, w, h)
                        // 图像质量
                        if (fileObj.quality && fileObj.quality <= 1 && fileObj.quality > 0) {
                            quality = fileObj.quality
                        }
                        // quality值越小，所绘制出的图像越模糊
                        const data = canvas.toDataURL(fileObj.type, quality);
                        // 压缩完成执行回调
                        const newFile = _this.convertBase64UrlToBlob(data,fileObj.name,fileObj.type);
                        newFile.uid = fileObj.uid;
                        callback(newFile);
                    }
                } catch (e) {
                    console.log('图片压缩失败');
                    callback(fileObj);
                }
            },
            convertBase64UrlToBlob(urlData,filename, type) {
                const bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte
                // 处理异常,将ascii码小于0的转换为大于0
                const ab = new ArrayBuffer(bytes.length)
                const ia = new Uint8Array(ab)
                for (let i = 0; i < bytes.length; i++) {
                    ia[i] = bytes.charCodeAt(i)
                }
                return new File([ab],filename,{ type: type })
            },
            beforeUpload(file) {
                this.fileSize += (file.size || 0);
                setTimeout(() => {
                    this.tip = false;
                }, 2000)
                if(this.fileSize/1024/1024 > (this.size ? this.size : 300)) {
                    if(!this.tip) {
                        this.$message.warning(`总大小不得超过${this.size ? this.size : 300}M！`);
                    }
                    this.tip = true;
                    this.fileSize -= (file.size || 0);
                    return false;
                }
                if(this.fileList.length >= (this.limit ? this.limit : 10)) {
                    if(!this.tip) {
                        this.$message.warning(`附件数量上限${this.limit ? this.limit : 10}个！`);
                    }
                    this.tip = true;
                    return false;
                }
                this.fileList.push(file);
            },
            exceed(files, fileList) {
                this.$message.warning(`附件数量上限${this.limit ? this.limit : 10}个！`)
            },
            delFile(file,i) {
                this.fileSize -= this.fileList[i].size;
                this.fileList.splice(i, 1);
                this.$refs.upload.abort(file);
                this.$refs.upload.uploadFiles.splice(i, 1);
                this.$emit('fileChange', file, 'del', i);
            },
        }
    }
</script>
<style lang="less" scoped>
    .upload_desc{
        color: #999;
    }
</style>


// WEBPACK FOOTER //
// src/components/file/upload.vue